import { render, staticRenderFns } from "./scissors.vue?vue&type=template&id=99dad108&"
import script from "./scissors.vue?vue&type=script&lang=js&"
export * from "./scissors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99dad108')) {
      api.createRecord('99dad108', component.options)
    } else {
      api.reload('99dad108', component.options)
    }
    module.hot.accept("./scissors.vue?vue&type=template&id=99dad108&", function () {
      api.rerender('99dad108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/scissors.vue"
export default component.exports